// 保险出行目的地国家和地区的列表，按拼音顺序展示
export default [
  '阿尔巴尼亚',
  '阿尔及利亚',
  '阿富汉',
  '阿根廷',
  '阿拉伯联合酋长国',
  '阿曼',
  '阿塞拜疆',
  '阿森松(英)',
  '埃及',
  '埃塞俄比亚',
  '爱尔兰',
  '爱沙尼亚',
  '安道尔',
  '安哥拉',
  '奥地利',
  '澳大利亚',
  '巴布亚新几内亚',
  '巴哈马',
  '巴基斯坦',
  '巴拉圭',
  '巴林',
  '巴拿马',
  '巴西',
  '白俄罗斯',
  '保加利亚',
  '贝宁',
  '比利时',
  '冰岛',
  '波兰',
  '波利尼西亚',
  '波斯尼亚和黑塞哥维',
  '玻利维亚',
  '伯利兹',
  '博茨瓦纳',
  '不丹',
  '布基纳法索',
  '布隆迪',
  '朝鲜',
  '赤道几内亚',
  '丹麦',
  '德国',
  '迪戈加西亚',
  '东萨摩亚（美）',
  '多哥',
  '俄罗斯',
  '厄瓜多尔',
  '厄立特里亚',
  '法国',
  '法罗群岛',
  '法属圭亚那',
  '菲律宾',
  '斐济',
  '芬兰',
  '佛得角',
  '福克兰群岛',
  '冈比亚',
  '刚果',
  '哥伦比亚',
  '哥斯达黎加',
  '格陵兰岛',
  '格鲁吉亚',
  '古巴',
  '圭亚那',
  '哈萨克斯坦',
  '海地',
  '韩国',
  '荷兰',
  '荷属安的列斯群岛',
  '洪都拉斯',
  '基里巴斯',
  '吉布提',
  '吉尔吉斯斯坦',
  '几内亚',
  '几内亚比绍',
  '加拿大',
  '加纳',
  '加篷',
  '柬埔寨',
  '捷克',
  '津巴布韦',
  '喀麦隆',
  '卡塔尔',
  '科克群岛(新)',
  '科摩罗',
  '科特迪瓦',
  '科威特',
  '克罗地亚',
  '肯尼亚',
  '拉脱维亚',
  '莱索托',
  '老挝',
  '黎巴嫩',
  '立陶宛',
  '利比里亚',
  '利比亚',
  '留尼汪岛（法）',
  '卢森堡',
  '卢旺达',
  '罗马尼亚',
  '马达加斯加',
  '马尔代夫',
  '马耳他',
  '马拉维',
  '马来西亚',
  '马里',
  '马其顿',
  '马绍尔群岛',
  '马提尼克（法）',
  '马约特岛',
  '毛里求斯',
  '毛里塔尼亚',
  '美国',
  '蒙古',
  '孟加拉国',
  '秘鲁',
  '密克罗尼西亚',
  '缅甸',
  '摩尔多瓦',
  '摩洛哥',
  '摩纳哥',
  '莫桑比克',
  '墨西哥',
  '纳米比亚',
  '南非',
  '南斯拉夫',
  '瑙鲁',
  '尼加拉瓜',
  '尼泊尔',
  '尼日尔',
  '尼日利亚',
  '纽埃岛（新）',
  '挪威',
  '诺福克岛（澳）',
  '帕劳',
  '葡萄牙',
  '日本',
  '瑞典',
  '瑞士',
  '萨尔瓦多',
  '塞班岛（北马里亚纳群岛）',
  '塞内加尔',
  '塞浦路斯',
  '塞舌尔',
  '赛拉利昂',
  '桑给巴尔',
  '沙特阿拉伯',
  '圣多美和普林西比',
  '圣赫勒拿',
  '圣马力诺',
  '圣皮埃尔岛和密克隆',
  '斯里兰卡',
  '斯洛伐克',
  '斯洛文尼亚',
  '斯威士兰',
  '苏丹',
  '苏里南',
  '所罗门群岛（英）',
  '索马里',
  '塔吉克斯坦',
  '泰国',
  '坦桑尼亚',
  '汤加',
  '突尼斯',
  '图瓦卢',
  '土耳其',
  '土库曼斯坦',
  '托克劳群岛（新）',
  '瓦努阿图',
  '危地马拉',
  '委内瑞拉',
  '文莱',
  '乌干达',
  '乌克兰',
  '乌拉圭',
  '乌兹别克斯坦',
  '希腊',
  '西班牙',
  '西萨摩亚',
  '新加坡',
  '新喀里多尼亚群岛',
  '新西兰',
  '匈牙利',
  '叙利亚',
  '牙买加',
  '亚美尼亚',
  '也门',
  '伊拉克',
  '伊朗',
  '以色列',
  '意大利',
  '印度',
  '印度尼西亚',
  '英国',
  '约旦',
  '越南',
  '赞比亚',
  '扎伊尔',
  '乍得',
  '智利',
  '中非',
  '中国',
];



// WEBPACK FOOTER //
// ./src/datas/country.js